module.exports = __webpack_public_path__ + "img/b7.7d134c1d.png";